import { Navigate, Route, Routes } from "react-router-dom";
import { LinkReport } from "./link-report";

export function LinkReportRoutes({ index, api, config }) {
    return (
        <Routes>
            <Route index element={<Navigate to={index} replace={true} />} />
            <Route
                path=":report"
                element={<LinkReport api={api} config={config} />}
            />
        </Routes>
    );
}
